import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { documentsAPI } from '../services/api';
import { fmtDate } from '../utils/dateUtils';
import { parseApiError } from '../utils/errors';

// Shows documents recently attached to tasks so HR/admin know there are files
// to review, with direct View/Download. Clicking the task opens it.
export default function DocumentsToReview({ limit = 12 }) {
  const navigate = useNavigate();
  const [docs, setDocs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    documentsAPI.recent({ limit }).then(({ data }) => setDocs(data)).catch(() => {}).finally(() => setLoading(false));
  }, [limit]);

  const blobFrom = (res) => {
    const type = res.headers?.['content-type'] || res.data?.type || 'application/octet-stream';
    return new Blob([res.data], { type });
  };

  const view = async (d) => {
    try {
      const res = await documentsAPI.download(d.id);
      const url = URL.createObjectURL(blobFrom(res));
      window.open(url, '_blank', 'noopener');
      setTimeout(() => URL.revokeObjectURL(url), 60000);
    } catch (err) { alert(parseApiError(err, 'Could not open document')); }
  };

  const download = async (d) => {
    try {
      const res = await documentsAPI.download(d.id);
      const url = URL.createObjectURL(blobFrom(res));
      const a = document.createElement('a');
      a.href = url; a.download = d.original_filename || 'document'; a.click();
      URL.revokeObjectURL(url);
    } catch (err) { alert(parseApiError(err, 'Download failed')); }
  };

  if (loading) return null;

  return (
    <div className="card mt-6">
      <div className="card-header"><h3>📎 Documents to Review</h3></div>
      {docs.length === 0 ? (
        <div className="empty-state">No documents attached yet.</div>
      ) : (
        <table className="data-table">
          <thead>
            <tr><th>File</th><th>Task</th><th>Uploaded By</th><th>When</th><th>Actions</th></tr>
          </thead>
          <tbody>
            {docs.map((d) => (
              <tr key={d.id}>
                <td>📄 {d.original_filename}{d.file_size ? ` (${(d.file_size / 1024).toFixed(0)} KB)` : ''}</td>
                <td><span className="table-link" style={{ cursor: 'pointer' }} onClick={() => navigate(`/hr/tasks/${d.task_id}`)}>{d.task_title}</span></td>
                <td>{d.uploaded_by}</td>
                <td style={{ whiteSpace: 'nowrap' }}>{fmtDate(d.created_at)}</td>
                <td>
                  <div style={{ display: 'flex', gap: 6 }}>
                    <button className="btn btn-sm btn-ghost" onClick={() => view(d)}>View</button>
                    <button className="btn btn-sm btn-ghost" onClick={() => download(d)}>Download</button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
